import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AddPhoto from '@material-ui/icons/AddAPhoto';
import IconButton from '@material-ui/core/IconButton';
import { grey700, grey } from '@material-ui/core/colors';

import {
  EditableImage,
  injectIntl,
} from 'components';

const ProductItemImage = ({
  disabled, onUpload, onRemove, image, info, isGrid, reloadStore, requesting, title,
}) => {
  const handleUpload = ({ filetype, imageBase64, onRequestClose }) => {
    onUpload(info.id, {
      base64: imageBase64,
      filetype,
      onSuccess: () => {
        onRequestClose();
        reloadStore();
        // window.location.reload();
      },
    });
  };
  const handleRemove = ({ onRequestClose }) => {
    onRemove(info.id, '' /** indicating no image id in the path */, {
      onSuccess: () => {
        onRequestClose();
        reloadStore();
      },
    });
  };

  const renderer = ({ onClick, uploadImageDialog }) => (
    <div>
      {!isGrid && image ? (
        <img
          src={image}
          alt=""
          className="upload-photo-button"
          onClick={disabled ? null : onClick}
          disabled={disabled}
          style={{
            height: 40,
            width: 40,
          }}
          title={title}
        />
      ) : (
        <div title={title}>
          <IconButton
            disabled={disabled}
            onClick={onClick}
            style={{
              height: 40,
              padding: 5,
              width: 40,
            }}
          >
            <AddPhoto style={ isGrid ? { color: grey[50] }: {color: grey700}}  />
          </IconButton>
        </div>
      )}
      {uploadImageDialog}
    </div>
  );

  renderer.propTypes = {
    onClick: PropTypes.func.isRequired,
    uploadImageDialog: PropTypes.node.isRequired,
  };

  return (
    <EditableImage
      image={image}
      onUpload={handleUpload}
      onRemove={handleRemove}
      renderer={renderer}
      requesting={requesting}
    />
  );
};

ProductItemImage.propTypes = {
  disabled: PropTypes.bool,
  image: PropTypes.string,
  info: PropTypes.shape({}),
  requesting: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  isGrid: PropTypes.bool,

  onUpload: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  reloadStore: PropTypes.func.isRequired,
};

ProductItemImage.defaultProps = {
  disabled: false,
  image: '',
  info: {},
  isGrid: false,
};

/* istanbul ignore next */
const mapStateToProps = (/* state */) => ({
});

const wrappedProductItemImage = connect(mapStateToProps)(injectIntl(ProductItemImage));
wrappedProductItemImage.displayName = 'ProductItemImage';

export default wrappedProductItemImage;
